<GlobalNav />
<div class="section" id="home">
  <div class="container">
    <Heading />

    <div class="columns has-text-centered">
      {#each homeItems as item}
        <a
          on:click="{() => push(item.path)}"
          class="column is-half-desktop has-text-centered"
        >
          <div class="has-text-dark">
            {#if item.image}
              <div
                class="chapter-image-container"
                style="background-image: url({item.image})"
              ></div>
            {:else}
              <div class="circle-icon-container"><img src="{item.icon}" /></div>
            {/if}
            <h3 class="is-size-4 mt-4">{item.title}</h3>
          </div>
        </a>
      {/each}
    </div>
  </div>
</div>

<script>
import { push } from "svelte-spa-router";
import GlobalNav from "./GlobalNav.svelte";
import Heading from "./Heading.svelte";
import { club } from "./stores";

let homeItems = [
  {
    title: "Deine Platzreife",
    path: "/platzreife",
    icon: "https://be-golf.schmerzhilfe-online.de/app/uploads/2021/01/golf.png",
  },
  {
    title: "Dein Club",
    path: "/ueber-uns",
    icon:
      "https://be-golf.schmerzhilfe-online.de/app/uploads/2021/02/golf-cart.png",
  },
];

// Set Golfclub image
club.subscribe((c) => {
  if (c?.golfclub?.image) {
    if (homeItems.length > 1) {
      homeItems[1].image = c.golfclub.image;
    }
    homeItems = homeItems;
  }
});
</script>

<style type="text/scss">
@import "./scss/colors";
.is-max-width-90 {
  max-width: 90%;
}
.circle-icon-container:hover {
  box-shadow: 0 0 20px #555;
}
.circle-icon-container {
  width: 59%;
  margin: 0 auto;
  border-radius: 30px;
  border: 2px solid $color-dark-grey;
  padding: 70px;
  transition: all 0.3s ease;
}
.chapter-image-container:hover {
  box-shadow: 0 0 20px #555;
}
.chapter-image-container {
  width: 90%;
  padding-bottom: 60%;
  margin: 0 auto;
  border-radius: 30px;
  border: 2px solid $color-dark-grey;
  transition: all 0.3s ease;
  background-position: center center;
  background-size: cover;
  @media screen and (max-width: 1024px) {
    width: 80%;
  }
}
</style>
